export const envConfig = {
    API_URL: process.env.REACT_APP_API_URL || 'https://dev-api-myatf.atf.fr/rest',
    MYATF_URL: process.env.REACT_APP_MYATF_URL || 'https://localhost:3001',
    isDev: !!process.env.REACT_APP_DEV,
};
